import React from 'react';
import {
  AggregateRating,
  Author,
  Generic,
  GenericCollection,
  JSONLD,
  Product,
  Rating,
  Review
} from 'react-structured-data';
import {getImgixUrl} from '@/utils/helper';
import {getColors, isPreOrder} from "@/models/product";
import {isQuickShip} from "@/common/QuickShip";
import { ItemAvailability, SCHEMA_ORG_URL } from "./constants";


function JsonLDProduct({ product }) {
  if (!product.id) {
    return null;
  }

  let ratingValue, reviewCount, subcategoryId,
    categoryName, collectionName, mainImage = [], alternateImages = [];
  const name = product?.name;

  if (product?.images.length > 0) {
    mainImage.push(getImageUrl(product.images[0].path));
    alternateImages = product.images.slice(1).map(
      ({path}) => getImageUrl(path)
    );
  }

  const description = product.frame ? product.frame.description : name;

  if (product.frame?.subcategories?.length > 0) {
    const subcategory = product.frame.subcategories[0];
    subcategoryId = subcategory.id;
    ratingValue = subcategory.avg_rating;
    reviewCount = subcategory.total_reviews;
    categoryName = subcategory.category?.name;
    collectionName = subcategory.name;
  }


  return (
    <>
      <JSONLD>
        <Product
          color={getColors(product)}
          description={description}
          image={mainImage}
          inProductGroupWithID={subcategoryId}
          material={product.fabric?.material?.name}
          mpn={product.id}
          name={name}
          pattern={product.fabric?.pattern?.name}
          sku={product.sku}
          weight={product.frame?.weight}
          countryOfOrigin={product.frame?.country_of_origin}
          shippingRate={product.shipping_rate}
          category={product.havenlyTaxonomy}
        >
          <Generic
            type="brand"
            jsonldtype="Brand"
            schema={{
              name: "The Inside"
            }}
          />
          {reviewCount > 0 && ratingValue != null && (
            <AggregateRating
              ratingValue={Number(ratingValue / 2).toFixed(2)}
              reviewCount={reviewCount}
            />
          )}

          {product.bestReview && (
            <GenericCollection type="review">
              <Review
                name={product.bestReview.title}
                reviewBody={product.bestReview.message}
              >
                <Author
                  name={
                    product.bestReview.user.first_name +
                    ' ' +
                    product.bestReview.user.last_name
                  }
                />
                <Rating
                  ratingValue={Number(product.bestReview.rating / 2).toFixed(2)}
                />
              </Review>
            </GenericCollection>
          )}

          <Generic
            type="offers"
            jsonldtype="Offer"
            schema={{
              url: product.url,
              priceCurrency: 'USD',
              price: product.price,
              itemCondition: `${SCHEMA_ORG_URL}/NewCondition`,
              availability: getAvailability(product),
            }}
          >
            <Generic
              type="seller"
              jsonldtype="Organization"
              schema={{name: 'The Inside'}}
            />
          </Generic>

          <Generic
            type="custom"
            schema={{
              dimensions: product.frame?.dimensions,
              category: product.havenlyTaxonomy,
              alternateImages,
              quickShip: isQuickShip(product),
              wholesalePrice: product.cost,
              collectionName
            }}
          />
        </Product>
      </JSONLD>
    </>
  );
}
function getAvailability(product) {
  if (isPreOrder(product.id)) {
    return ItemAvailability.PRE_ORDER;
  }

  if (!product.is_purchasable) {
    return ItemAvailability.OUT_OF_STOCK;
  }

  if (!!product.uses_inventory && product.current_inventory < 1) {
    return ItemAvailability.OUT_OF_STOCK;
  }

  return ItemAvailability.IN_STOCK;
}

function getImageUrl(path) {
  return `${getImgixUrl(path)}?auto=format&w=500`;
}

export default JsonLDProduct;
